module.exports = __webpack_public_path__ + "img/illusThrones6.7e9a146b.jpg";